import { ErrorMessages, LegsSystem } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';

const addLegs = ({ coreApi, props }: BehaviorParameters) => {
  const system = coreApi.getSystem<LegsSystem>('LegsSystem');
  if (!system) {
    return;
  }
  const placementResults = system.updateLegsWithHistory(props.coreProductId);
  const legsCollision = placementResults
    .map(p => p?.errors)
    .flat()
    .find(e => (e as any)?.collisions?.length > 0);

  const determinePlacementAttemptErrorMessage = () => {
    if (!hideNoFramesInSceneErrorMessage(coreApi)) {
      return ErrorMessages.NoFramesInScene;
    } else if (legsCollision) {
      return ErrorMessages.LegsWontFit;
    }
    return null;
  };
  const placementAttemptErrorMessage = determinePlacementAttemptErrorMessage();
  if (placementAttemptErrorMessage) {
    coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
  }
};

export default addLegs;
